// extracted by mini-css-extract-plugin
export var blue = "bv_dB";
export var dark = "bv_cy";
export var gold = "bv_dC";
export var gray = "bv_dD";
export var iconMain = "bv_dJ";
export var light = "bv_cw";
export var magenta = "bv_dH";
export var none = "bv_dF";
export var orange = "bv_dG";
export var original = "bv_dz";
export var root = "bv_dy";
export var tan = "bv_cg";